// Fancybox
import { Fancybox } from "@fancyapps/ui";
import { fr } from '@fancyapps/ui/dist/fancybox/l10n/fr.umd.js';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

document.addEventListener('DOMContentLoaded', () => {
    //fancybox
    Fancybox.defaults.Hash = false;
    Fancybox.bind('[data-fancybox]', {
        Thumbs: {showOnStart: false},
        Carousel: {transition: 'crossfade'},
        l10n: fr
    });
});
